








































































import {Component, Prop, Vue} from 'vue-property-decorator';
import user from '@/store/modules/user';

@Component
export default class StartCompanyItem extends Vue {
    @Prop() readonly type!: string;

    get user() {
        return user.user;
    }
}
